import { render, staticRenderFns } from "./TerminalCreator.vue?vue&type=template&id=ef57216e&scoped=true"
import script from "./TerminalCreator.vue?vue&type=script&lang=ts"
export * from "./TerminalCreator.vue?vue&type=script&lang=ts"
import style0 from "./TerminalCreator.vue?vue&type=style&index=0&id=ef57216e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef57216e",
  null
  
)

export default component.exports